
import React from "react";
import { Search, Loader2, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  isSearching?: boolean;
  className?: string;
  variant?: 'standalone' | 'sidebar';
}

export const SearchBar: React.FC<SearchBarProps> = ({ 
  searchTerm, 
  setSearchTerm, 
  isSearching = false,
  className,
  variant = 'standalone'
}) => {
  const clearSearch = () => {
    setSearchTerm('');
  };

  return (
    <div className={cn("relative group", className)}>
      {/* Search icon or spinner on the left */}
      <div className="absolute left-0 inset-y-0 flex items-center pl-3.5 pointer-events-none">
        {isSearching ? (
          <Loader2 className="w-4 h-4 text-white/70 animate-spin" />
        ) : (
          <Search 
            className={`w-4 h-4 transition-all ${
              searchTerm 
                ? "text-white/80" 
                : "text-white/50 group-hover:text-white/70"
            }`} 
          />
        )}
      </div>
      
      <Input 
        type="search"
        placeholder="Buscar conversas ou mensagens..."
        className={cn(
          "pl-11 pr-11 bg-white/10 backdrop-blur-sm border-white/20 text-white rounded-md focus-visible:ring-luxury-red focus-visible:border-luxury-red/50 transition-all hover:bg-white/15 placeholder:text-white/50",
          variant === 'standalone' ? "py-2" : "py-1.5 text-sm"
        )}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* Clear button (X) on the right - only show when there's text */}
      {searchTerm && (
        <button
          onClick={clearSearch}
          className="absolute right-0 inset-y-0 flex items-center pr-3.5 text-luxury-red hover:text-luxury-red/80 transition-colors"
          type="button"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
